import { createRouter, createWebHistory, } from "vue-router";
import routes from "./routes.js";
import navigationGuards from "./guards";

const router = createRouter({
  history: createWebHistory(),
  routes,
});

navigationGuards(router);

export default router;
